module.exports = "https://web-assets.ifttt.com/packs/media/shared/encryption_lock_icon-85dfc830.svg";